export type ISSUE_OR_CANCEL = 'ISSUE' | 'CANCEL' | 'FONG';
export type INSTRUMENT_ACTIONS = ISSUE_OR_CANCEL | 'FONG' | 'CANCEL' | 'CLOSE' | 'REOPEN';
